import { SamplePaymentTreatment } from '@codezo/graphql';

/**
 * Client-facing wording for the three payment treatments.
 *
 * Same concept as the admin app's copy of this, deliberately worded for the
 * person paying: "your order", and a free sample says so plainly rather than
 * describing a treatment. The enum values are presentation — the backend has no
 * field for them and shouldn't.
 *
 * Both match the quote PDF, which prints "(deducted from your order)" and
 * "(waived)" — the client should read the same words on screen and on the
 * document they are sent.
 */
export const TREATMENT_LABEL: Record<SamplePaymentTreatment, string> = {
	[SamplePaymentTreatment.Charged]: 'Charged',
	[SamplePaymentTreatment.Prepaid]: 'Deducted from your order',
	[SamplePaymentTreatment.Waived]: 'Waived',
};

/**
 * Only the two non-default treatments earn a marker. CHARGED is the ordinary
 * case — the price shown beside it already says what happens.
 */
export const treatmentMarker = (treatment: SamplePaymentTreatment): string | null =>
	treatment === SamplePaymentTreatment.Charged ? null : TREATMENT_LABEL[treatment];
